import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/overview_/sales-commission")({
  component: SalesCommissionLayout,
});

function SalesCommissionLayout() {
  return <Outlet />;
}
